export default __webpack_public_path__ + "static/media/vegetable-enabled.da90489c.webp";